import notFoundPage from "./notFoundPage"
export default notFoundPage;
